(function () {
    // ---- config -----------------------------------------------------------
    var FEED = 'https://n8n-shaf-u71178.vm.elestio.app/webhook/recent-sales';
    var FIRST_DELAY = 8000;   // ms before the first popup
    var VISIBLE_MS  = 6000;   // how long each popup stays
    var GAP_MS      = 14000;  // gap between popups
    var MAX_AGE_H   = 168;    // ignore sales older than 7 days entirely
    // -----------------------------------------------------------------------

    function relTime(ms) {
      var mins = Math.round(ms / 60000);
      if (mins < 60) return mins + ' min ago';
      var hrs = Math.round(mins / 60);
      return hrs + (hrs === 1 ? ' hour ago' : ' hours ago');
    }

    function start(items) {
      var el = document.getElementById('sm-sp');
      if (!el || !items || !items.length) return;
      if (sessionStorage.getItem('sm-sp-dismissed') === '1') return;

      var link = el.querySelector('.sm-sp__link');
      var img = el.querySelector('.sm-sp__img');
      var titleEl = el.querySelector('.sm-sp__title');
      var metaEl = el.querySelector('.sm-sp__meta');
      var closeBtn = el.querySelector('.sm-sp__close');
      // Resume from where the previous page left off (per browser session)
      var IDXKEY = 'sm-sp-idx';
      var idx = parseInt(sessionStorage.getItem(IDXKEY) || '0', 10);
      if (isNaN(idx) || idx < 0) idx = 0;
      var hideTimer, nextTimer;

      function drawerOpen() {
        var menu = document.getElementById('Details-menu-drawer-container');
        var cart = document.querySelector('cart-drawer.active');
        return (menu && menu.open) || !!cart;
      }
      function render(p) {
        img.src = p.i || ''; img.alt = p.t || '';
        link.href = p.u || '#';
        titleEl.textContent = p.t || '';
        // 24h rule: only show timing if the sale is recent enough
        var when = '';
        if (p.ts) {
          var age = Date.now() - new Date(p.ts).getTime();
          if (age >= 0 && age <= 24 * 3600 * 1000) when = ' · ' + relTime(age);
        }
        var city = (p.city || '').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        var who = city ? 'Someone in ' + city : 'Someone';
        metaEl.textContent = who + ' bought this' + when;
        el.hidden = false;
        requestAnimationFrame(function () { el.classList.add('is-visible'); });
        hideTimer = setTimeout(hide, VISIBLE_MS);
      }
      function show() {
        if (drawerOpen()) { nextTimer = setTimeout(show, 3000); return; } // wait, don't cover the drawer
        var p = items[idx % items.length]; idx++;
        try { sessionStorage.setItem(IDXKEY, idx); } catch (e) {}
        // Preload the image BEFORE revealing so we never flash the previous
        // notification's picture and then jitter to the right one.
        if (p.i) {
          var pre = new Image();
          pre.onload = function () { render(p); };
          pre.onerror = function () { render(p); };
          pre.src = p.i;
        } else {
          render(p);
        }
      }
      function hide() {
        el.classList.remove('is-visible');
        nextTimer = setTimeout(show, GAP_MS);
      }
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        clearTimeout(hideTimer); clearTimeout(nextTimer);
        el.classList.remove('is-visible');
        sessionStorage.setItem('sm-sp-dismissed', '1');
      });

      setTimeout(show, FIRST_DELAY);
    }

    function load() {
      fetch(FEED, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = Array.isArray(data) ? data : (data.items || data.list || []);
          var cutoff = Date.now() - MAX_AGE_H * 3600 * 1000;
          var clean = list.filter(function (p) {
            if (!p || !p.t) return false;
            if (p.ts && new Date(p.ts).getTime() < cutoff) return false;
            return true;
          });
          start(clean);
        })
        .catch(function () {}); // silent: no feed -> no popup, never fake data
    }

    function boot() {
      if ('requestIdleCallback' in window) requestIdleCallback(load, { timeout: 4000 });
      else setTimeout(load, 1500);
    }
    if (document.readyState === 'complete') boot();
    else window.addEventListener('load', boot);
  })();
